<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cnWGlK/media/FC-9781398487772.jpg?1684514755425" alt="This image is the cover for the book Brushstrokes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brushstrokes
      </h1>
      <p class="bookDescription body article font2">
        <p>And for a brief moment, we finally set aside The shield that we don, beneath which our hearts hide Brushstrokes is an exploration of the nuances of love, the ebb and flow of hope, as well as the search for meaning, clarity and purpose. A moving composition of poems and prose, it recounts the tale of an electric encounter and ensuing, all-consuming love – with its irresistible highs and perilous lows – that sets into motion a cascade of events. What unfolds is a transformative story of self-discovery, unveiling one’s deepest fears, longings and dreams. Timeless and universal in message, Brushstrokes invites us on an intimate journey steeped in passion and wonder.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sabrina Marzaro
      </h2>
      
      <p class="authorDescription body article">An Italian-American writer residing between Paris and New York, Sabrina Marzaro has developed her career in the luxury realm, specialising in marketing and communications. Passionate about weaving words and sculpting stories that inspire, she is a copywriter and strategic consultant for prestigious brands such as Guerlain, Clarins and L’Oréal, for whom her work has been published internationally. Her expertise and entrepreneurial ventures led her to become Professor of Creative Strategies at New York’s Fashion Institute of Technology (FIT), as well as to share her knowledge through conferences held for various organisations in the luxury and creative fields. Brushstrokes is her second publication, following her first book, Swiping for Prince Charming.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09a75907